import React from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { observer } from 'mobx-react-lite';
import { ApplicationSdk } from '../../stores';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { PickList } from 'primereact/picklist';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tooltip } from 'primereact/tooltip';
import UploadImageDialog from "./upload/UploadImageDialog";

const ProductObjectList = observer(({ store }: { store: any }) => {
    // const handleAddObject = () => {
    //     if (selectedUnassignedObject && !store.assignedObjects.includes(selectedUnassignedObject)) {
    //         store.assignedObjects.push(selectedUnassignedObject);
    //         setSelectedUnassignedObject(null);
    //     }
    // };

    // const handleRemoveObject = () => {
    //     if (selectedAssignedObject) {
    //         store.assignedObjects = store.assignedObjects.filter((obj: any) => obj !== selectedAssignedObject);
    //         setSelectedAssignedObject(null);
    //     }
    // };

    const itemTemplate = (item: any) => {
        return (
            <div className="flex flex-wrap p-2 align-items-center gap-3">
                {/* <img className="w-4rem shadow-2 flex-shrink-0 border-round" src={`https://primefaces.org/cdn/primereact/images/product/${item.image}`} alt={item.name} /> */}
                <div className="flex-1 flex flex-column gap-2">
                    <span style={{ textAlign: 'left' }}>{item.name}</span>
                    {/* <div className="flex align-items-center gap-2">
                        <i className="pi pi-tag text-sm"></i>
                        <span>{item.category}</span>
                    </div> */}
                </div>
                {/* <span className="font-bold text-900">${item.price}</span> */}
            </div>
        );
    };

    const onChange = (event: any) => {
        store.updateProductAssignment(event.source, event.target);
    };



    return (
        <div style={{ marginTop: '2rem' }}>
            <ProductAvailableAllSwitcher store={store} />
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                {!store.isAvailableForAll ? (
                    // <>
                    //     <div style={{ flex: '1 1 50%' }}>
                    //         <h4>Verfügbare Objekte</h4>
                    //         {/* <ListBox
                    //             filter
                    //             optionLabel="name"
                    //             value={selectedUnassignedObject}
                    //             options={unassignedObjects}
                    //             // onChange={(e) => setSelectedUnassignedObject(e.value)}
                    //             style={{ marginBottom: '1rem', minHeight: 400, maxHeight: 400, overflow: 'auto', textAlign: 'left' }}

                    //         /> */}
                    //         {/* <VirtualScroller
                    //             items={unassignedObjects}
                    //             itemSize={50}
                    //             itemTemplate={itemTemplate}
                    //             className="border-1 surface-border border-round"
                    //             style={{ minHeight: 400, maxHeight: 400, marginBottom: '1rem', textAlign: 'left' }}
                    //         /> */}
                    //         <Button label="Hinzufügen" onClick={handleAddObject} />
                    //     </div>
                    //     <div style={{ flex: '1 1 50%' }}>
                    //         <h4>Zugewiesene Objekte</h4>
                    //         <ListBox
                    //             filter
                    //             value={selectedAssignedObject}
                    //             options={assignedObjects}
                    //             onChange={(e) => setSelectedAssignedObject(e.value)}
                    //             style={{ marginBottom: '1rem', minHeight: 400, maxHeight: 400, overflow: 'auto' }}
                    //         />
                    //         <Button label="Entfernen" onClick={handleRemoveObject} />
                    //     </div>
                    // </>
                    <>
                        <PickList
                            dataKey="id"
                            source={store.unassignedObjectsArray}
                            target={store.assignedObjectsArray}
                            onChange={onChange}
                            itemTemplate={itemTemplate}
                            filter
                            showTargetControls={false}
                            showSourceControls={false}
                            filterBy="name"
                            breakpoint="1280px"
                            sourceHeader="Verfügbare Objekte"
                            targetHeader="Ausgewählte Objekte"
                            sourceStyle={{ height: '20rem' }}
                            targetStyle={{ height: '20rem' }}
                            sourceFilterPlaceholder="Search by name"
                            targetFilterPlaceholder="Search by name"
                        />
                    </>
                ) : null}
            </div>
        </div>
    );
});

const ProductTitle = observer(({ store }: { store: any }) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length <= 80) {
            store.productName = e.target.value;
        }
    };

    return (
        <div style={{ marginBottom: '1rem', width: '100%' }}>
            <label htmlFor="productName" style={{ display: 'block', marginBottom: '0.5rem' }}>Produktname</label>
            <InputText
                id="productName"
                placeholder="Produktname"
                value={store.productName}
                onChange={handleInputChange}
                style={{ width: '100%' }}
                data-pr-tooltip="Der Produkt Titel muss mindestens 3 Zeichen lang sein."
                data-pr-position="top"
                data-pr-disabled={store.validTitle}
                invalid={!store.validTitle}
            />
            <Tooltip target="#productName" />
        </div>
    );
});

const ProductArticleNumber = observer(({ store }: { store: any }) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        store.articleNumber = e.target.value;
    };

    return (
        <div style={{ marginBottom: '1rem', width: '100%' }}>
            <label htmlFor="articleNumber" style={{ display: 'block', marginBottom: '0.5rem' }}>Artikelnummer</label>
            <InputText
                id="articleNumber"
                placeholder="Artikelnummer"
                value={store.articleNumber}
                onChange={handleInputChange}
                style={{ width: '100%' }}
                data-pr-tooltip="Die Artikelnummer muss eine Zahl zwischen 1 und 9999 sein"
                data-pr-position="top"
                data-pr-disabled={store.validArticleNumber}
                invalid={!store.validArticleNumber}
            />
            <Tooltip target="#articleNumber" />
        </div>
    );
});

const ProductDescription = observer(({ store }: { store: any }) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        store.productDescription = e.target.value;
    };

    return (
        <div style={{ marginBottom: '1rem', width: '100%' }}>
            <label htmlFor="productDescription" style={{ display: 'block', marginBottom: '0.5rem' }}>Produktbeschreibung</label>
            <InputTextarea
                id="productDescription"
                placeholder="Produktbeschreibung"
                value={store.productDescription}
                onChange={handleInputChange}
                rows={5}
                cols={30}
                style={{ width: '100%' }}
            />
        </div>
    );
});

const ProductPaidSwitcher = observer(({ store }: { store: any }) => {
    return (
        <div className="p-field-checkbox" style={{ marginBottom: '1rem' }}>
            <Checkbox
                inputId="isPaid"
                checked={store.isPaid}
                onChange={() => store.switchPaid()}
            />
            <label htmlFor="isPaid">Kostenpflichtig</label>
        </div>
    );
});

const ProductAvailableAllSwitcher = observer(({ store }: { store: any }) => {
    return (
        <div className="p-field-checkbox" style={{ marginBottom: '1rem' }}>
            <Checkbox
                inputId="isAvailableForAll"
                checked={store.isAvailableForAll}
                onChange={() => store.switchProductAllProducts()}
            />
            <label htmlFor="isAvailableForAll">Allen Objekten zugewiesen</label>
        </div>
    );
});

const ProductUnit = observer(({ store }: { store: any }) => {
    return <>
        <Dropdown
            id={'productUnit'}
            value={store.productUnit}
            onChange={(e) => store.selectUnit(e.value)}
            onShow={() => store.fetchUnits()}
            options={store.units}
            loading={store.isUnitLoading}
            optionLabel="name"
            placeholder="Wähle eine Einheit"
            className="w-full"
            checkmark={true}
            highlightOnSelect={false}
            data-pr-tooltip="Bitte gebe eine Einheit an"
            data-pr-position="top"
            data-pr-disabled={store.validUnit}
            invalid={!store.validUnit}
        />
        <Tooltip target="#productUnit" />
    </>;
});

const ProductCategory = observer(({ store }: { store: any }) => {
    return <>
        <Dropdown
            id={'productCategory'}
            value={store.productCategory}
            onChange={(e) => store.selectCategory(e.value)}
            // onShow={() => store.fetchCategories()}
            options={store.categories}
            loading={store.isLoading}
            optionLabel="name"
            placeholder="Wähle eine Kategorie"
            className="w-full md:w-14rem"
            checkmark={true}
            highlightOnSelect={false}
            data-pr-tooltip="Bitte gebe eine Kategorie an"
            data-pr-position="top"
            data-pr-disabled={store.validCategory}
            invalid={!store.validCategory}
        />
        <Tooltip target="#productCategory" />
    </>;
});


const ProductDialog = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    const store = sdk.currentDialog;

    const handleProductSave = async () => {
        try {
            await store.onSaveProduct();
            // Erfolgreich => Schließe nun die Ansicht
            sdk.closeDialog({
                event: 'SAVED'
            });
            sdk.showSuccessToast('Produkt gespeichert');
        } catch (error: any) {
            sdk.showErrorToast(error?.message || 'Unbekannter Fehler')
        }
    };

    const handleProductClone = async () => {
        store.clone(); // Führe die Klon-Logik aus
        sdk.showSuccessToast('Neue Produktvorlage erstellt');
    };

    const isSaveable = store.isValid && !store.isLoading;

    return (
        <Dialog
            visible={!!sdk.currentDialog}
            modal
            header={store?.header || ''}
            footer={() => (
                <div style={{ display: 'flex', justifyContent: store.isCloneable ? 'space-between' : 'flex-end' }}>
                    {store.isCloneable && (
                        <Button
                            label="Klonen"
                            icon="pi pi-copy"
                            className="p-button-secondary"
                            onClick={handleProductClone}
                        />
                    )}
                    <Button
                        label={store.saveButton}
                        icon="pi pi-check"
                        className="p-button-primary"
                        disabled={!isSaveable}
                        onClick={handleProductSave}
                    />
                </div>
            )}
            style={{ width: '80rem', height: '50rem' }}
            onHide={() => sdk.closeDialog()}
        >
            {store.isLoading ? (
                <div className="flex justify-content-center align-items-center" style={{ height: '100%' }}>
                    <ProgressSpinner />
                </div>
            ) : (
                <div className="dialog-content">
                    <div className={'left-column'}>
                        <div className={'card'}>
                            <UploadImageDialog store={store} />
                            <ProductTitle store={store} />
                            <ProductArticleNumber store={store} />
                            <ProductDescription store={store} />
                            <ProductPaidSwitcher store={store} />
                            <ProductUnit store={store} />
                        </div>
                    </div>
                    <div className={'right-column'}>
                        <div className={'card'}>
                            <ProductCategory store={store} />
                            <ProductObjectList store={store} />
                        </div>
                    </div>
                </div>
            )}
        </Dialog>
    );
});

export default ProductDialog;